export type JwtPayloadType = {
    aud: string | undefined;
    authorities: string[];
    exp: number;
    houseId: string;
    iat: number;
    iss: string;
    sub: string;
    token: string;
    username: string;
};

export const emptyJwtPayload: JwtPayloadType = {
    aud: '',
    authorities: [],
    exp: 0,
    houseId: '',
    iat: 0,
    iss: '',
    sub: '',
    token: '',
    username: '',
};
